import ApplicantInformations from './ApplicantInformations';

export default ApplicantInformations;
